import React from "react";
import {Spinner} from "react-bootstrap";
import FolieLayout from "./FolieLayout.jsx";
import BeispielArtikelAuswahl from "./BeispielArtikelAuswahl.jsx";
import BestellmengeSchaubild from "./BestellmengeSchaubild.jsx";
import {formatFarbnummer, formatMenge, produktlinieLabel} from "../format.js";

/**
 * Beleg-Zeile unter dem Schaubild (Befund S8, Sichtprüfung 3): folgt live
 * dem gerade gewählten Beispiel-Farbton statt einen einzelnen Farbton
 * fest zu nennen - sonst widerspricht der Beleg Auswahl und Balken, sobald
 * ein anderer Farbton gewählt wird.
 */
function belegSatz(artikelDaten) {
    const artikel = artikelDaten?.artikel;
    const zielbestand = artikelDaten?.prognose?.zielbestand?.wert;
    const bestellmenge = artikelDaten?.prognose?.szenarien?.erwartet?.bestellmenge?.wert;
    const rueckstand = artikelDaten?.offene_kundenmenge?.wert;
    const paletteStueck = artikel?.palette_stueck;

    if (!artikel || zielbestand === null || zielbestand === undefined || bestellmenge === null || bestellmenge === undefined) {
        return null;
    }

    const teile = [`Zielbestand ${formatMenge(zielbestand)}`];
    if (rueckstand !== null && rueckstand !== undefined) {
        teile.push(`Rückstand aus offenen Aufträgen ${formatMenge(rueckstand)}`);
    }
    teile.push(
        `Bestellmenge ${formatMenge(bestellmenge)} Dosen${paletteStueck ? ` (${formatMenge(bestellmenge / paletteStueck)} Paletten)` : ""}`
    );

    const bezeichnung = `${produktlinieLabel(artikel.produktlinie)} ${formatFarbnummer(artikel.farbnummer, artikel.farbnummer_unter)} ${
        artikel.farbname
    }`;

    return `Beleg für die Formel, live für den gewählten Farbton: Artikel ${artikel.artikel_nummer} (${bezeichnung}) – ${teile.join(", ")}.`;
}

export default function Folie6Bestellmenge({beispielArtikel, onBeispielArtikelAendern, artikelDaten, ladeGerade}) {
    const beleg = belegSatz(artikelDaten);

    return (
        <FolieLayout
            nummer={7}
            titel="Wie viel bestellen?"
            hilfe="Zielbestand minus Bestand bei Ankunft, mindestens der Rückstand aus offenen Aufträgen, aufgerundet auf volle Paletten – begrenzt durch die Lagerkapazität."
            text={
                <p className="mb-0">
                    Die Bestellmenge ergibt sich aus dem Zielbestand minus dem Bestand, der bei der idealen Ankunft
                    voraussichtlich noch da ist. Reicht das nicht für die offenen Kundenaufträge, wird mindestens der
                    Rückstand nachbestellt. Aufgerundet wird auf volle Paletten – würde das über die Lagerkapazität
                    hinausgehen, wird stattdessen abgerundet, denn eine Bestellung, die nicht ins Lager passt, nützt
                    niemandem.
                </p>
            }
            leseHinweis="Die Balken zeigen Mindestbestand, Zielbestand, die Lagerkapazität (falls gepflegt) und die daraus errechnete Bestellmenge des gewählten Farbtons, in Dosen und in Paletten."
        >
            <BeispielArtikelAuswahl wert={beispielArtikel} onChange={onBeispielArtikelAendern} />
            {!artikelDaten && ladeGerade && (
                <div className="d-flex justify-content-center py-4">
                    <Spinner animation="border" size="sm" role="status">
                        <span className="visually-hidden">Wird geladen…</span>
                    </Spinner>
                </div>
            )}
            {artikelDaten && (
                <BestellmengeSchaubild
                    prognose={artikelDaten.prognose}
                    lagerkapazitaetStueck={artikelDaten.artikel?.lagerkapazitaet_stueck}
                    paletteStueck={artikelDaten.artikel?.palette_stueck}
                />
            )}
            {beleg && <div className="small text-muted mt-2">{beleg}</div>}
        </FolieLayout>
    );
}
